import { render } from "./BackgroundInfoForm.vue?vue&type=template&id=035d4bc6"
import script from "./BackgroundInfoForm.vue?vue&type=script&lang=js"
export * from "./BackgroundInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gods1son\\myApplications\\Schooliply\\schooliply-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__